import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    FinancialTransactionsParameter,
    getFinancialTransactions,
    SurFinancialTransactionsModel,
} from "@tSurya/Services/FinancialTransactions";
import { CustomApiHandler } from "@tSurya/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<FinancialTransactionsParameter, SurFinancialTransactionsModel>;

export const DispatchBeginFinancialTransaction: HandlerType = props => {
    props.dispatch({
        type: "Custom/FinancialTransaction/BeginLoadFinancialTransaction",
    });
};

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const StoreAPIParameterData: HandlerType = props => {
    if (!props.parameter) {
        return;
    }
    props.dispatch({
        type: "Custom/FinancialTransaction/CompletedLoadFinancialTransactionStore",
        searchparameter: props.apiParameter,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getFinancialTransactions(props.apiParameter);
};

export const DispatchCompleteFinancialTransactions: HandlerType = props => {
    if (!props.apiResult) {
        return;
    }

    props.dispatch({
        type: "Custom/FinancialTransaction/CompletedLoadFinancialTransaction",

        result: props.apiResult,
    });
};

export const chain = [
    DispatchBeginFinancialTransaction,
    PopulateApiParameter,
    StoreAPIParameterData,
    RequestDataFromApi,
    DispatchCompleteFinancialTransactions,
];

const loadFinancialTransaction = createHandlerChainRunner(chain, "loadFinancialTransaction");
export default loadFinancialTransaction;
